// 联系人相关接口
import request from '@/utils/request'

// 联系人列表接口
export function contactsList() {
  return request({
    url: '/cultureCantonDemoApi/contactsInfoApi/queryContactsInfoList',
    method: 'get',
  })
}

// 联系人添加
export function contactsAdd(data) {
  return request({
    url: '/cultureCantonDemoApi/contactsInfoApi/saveContactsInfo',
    method: 'post',
    data,
  })
}

// 联系人修改
export function contactsEdit(data) {
  return request({
    url: '/cultureCantonDemoApi/contactsInfoApi/updateContactsInfo',
    method: 'post',
    data,
  })
}

// 联系人删除
export function contactsDelete(id) {
  return request({
    url: `/cultureCantonDemoApi/contactsInfoApi/deleteContactsInfo?id=${id}`,
    method: 'get',
  })
}
